import React, { useState, useEffect } from 'react';
import './Recipes.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Recipe {
  id: number;
  videoId: string;
  title: string;
  description: string;
  image: string;
  difficulty: string;
  time: string;
  rating: number;
  category: string;
  cuisine: string;
}

export const recipes: Recipe[] = [
    {
      id: 1,
      videoId:"DpEQy08ohRg",
      title: 'New York Cheesecake',
      description: 'American classic, a rich and creamy dessert.',
      image: 'https://i.ytimg.com/vi/DpEQy08ohRg/hq720.jpg',
      difficulty: 'Medium',
      time: '80',
      rating: 4.8,
      category: 'Dessert',
      cuisine: 'American'
    },
    {
      id: 2,
      videoId:"o7d8s5GUksU",
      title: 'PANCAKE GIGANTI AMERICANI',
      description: 'Giant American pancakes for a hearty breakfast.',
      image: 'https://i.ytimg.com/vi/o7d8s5GUksU/hq720.jpg',
      difficulty: 'Easy',
      time: '10',
      rating: 4.7,
      category: 'Breakfast',
      cuisine: 'American'
    },
    {
      id: 3,
      videoId: "hAKNl1084D8",
      title: 'Hamburger',
      description: 'A delicious American-style hamburger for lunch.',
      image: 'https://i.ytimg.com/vi/hAKNl1084D8/hq720.jpg',
      difficulty: 'Medium',
      time: '25',
      rating: 4.9,
      category: 'Lunch',
      cuisine: 'American'
    },
    {
      id: 4,
      videoId: "5WkifcU27Ns",
      title: 'Chicken KFC',
      description: 'American-style fried chicken for dinner.',
      image: 'https://i.ytimg.com/vi/5WkifcU27Ns/hq720.jpg',
      difficulty: 'Medium',
      time: '35',
      rating: 4.6,
      category: 'Dinner',
      cuisine: 'American'
    },
    {
      id: 5,
      videoId:"CFOUQ6X93d4",
      title: 'Adana Kebabı',
      description: 'A traditional Turkish kebab for a spicy dinner.',
      image: 'https://i.ytimg.com/vi/CFOUQ6X93d4/hq720.jpg',
      difficulty: 'Medium',
      time: '40',
      rating: 4.9,
      category: 'Dinner',
      cuisine: 'Turkish'
    },
    {
      id: 6,
      videoId:"7rORG0W31aE",
      title: 'Etli Kuru Fasulye',
      description: 'A hearty Turkish bean stew with meat.',
      image: 'https://i.ytimg.com/vi/7rORG0W31aE/hq720.jpg',
      difficulty: 'Medium',
      time: '80',
      rating: 4.8,
      category: 'Dinner',
      cuisine: 'Turkish'
    },
    {
      id: 7,
      videoId:"CFd6Z5lhQxY",
      title: 'İslim Kebabı',
      description: 'A Turkish kebab with eggplant.',
      image: 'https://i.ytimg.com/vi/CFd6Z5lhQxY/hq720.jpg',
      difficulty: 'Medium',
      time: '80',
      rating: 4.7,
      category: 'Dinner',
      cuisine: 'Turkish'
    },
    {
      id: 8,
      videoId:"b4OvcqqjTe0",
      title: 'Fırında Patlıcan Kebabı',
      description: 'Baked eggplant kebab, a Turkish specialty.',
      image: 'https://i.ytimg.com/vi/b4OvcqqjTe0/hq720.jpg',
      difficulty: 'Medium',
      time: '65',
      rating: 4.8,
      category: 'Dinner',
      cuisine: 'Turkish'
    },
    {
      id: 9,
      videoId:"v-co2QDkTco",
      title: 'Şöbiyet',
      description: 'A creamy Turkish dessert with phyllo pastry.',
      image: 'https://i.ytimg.com/vi/v-co2QDkTco/hq720.jpg',
      difficulty: 'Medium',
      time: '50',
      rating: 4.9,
      category: 'Dessert',
      cuisine: 'Turkish'
    },
    {
      id: 10,
      videoId:"Cx_ZssNru1M",
      title: 'Şehriyeli Yoğurt Çorbası',
      description: 'A Turkish yogurt soup with orzo.',
      image: 'https://i.ytimg.com/vi/Cx_ZssNru1M/hq720.jpg',
      difficulty: 'Easy',
      time: '35',
      rating: 4.6,
      category: 'Soup',
      cuisine: 'Turkish'
    },
    {
      id: 11,
      videoId:"FBCzH1CcxCA",
      title: 'Lasagne alla bolognese',
      description: 'Classic Italian lasagne with a rich meat sauce.',
      image: 'https://i.ytimg.com/vi/FBCzH1CcxCA/hq720.jpg',
      difficulty: 'Medium',
      time: '300',
      rating: 4.9,
      category: 'Lunch',
      cuisine: 'Italian'
    },
    {
      id: 12,
      videoId:"QkzLqaHS2PE",
      title: 'Pasta e Ceci',
      description: 'An Italian pasta and chickpea soup.',
      image: 'https://i.ytimg.com/vi/QkzLqaHS2PE/hq720.jpg',
      difficulty: 'Easy',
      time: '50',
      rating: 4.7,
      category: 'Lunch',
      cuisine: 'Italian'
    },
    {
      id: 13,
      videoId:"Wo7wZnjX26w",
      title: 'Spaghetti alle vongole e limone',
      description: 'Spaghetti with clams and lemon, an Italian classic.',
      image: 'https://i.ytimg.com/vi/Wo7wZnjX26w/hq720.jpg',
      difficulty: 'Easy',
      time: '20',
      rating: 4.8,
      category: 'Lunch',
      cuisine: 'Italian'
    },
    {
      id: 14,
      videoId:"fxZWY0ncJ6E",
      title: 'Tiramisù della tradizione',
      description: 'Traditional Italian tiramisu for dessert.',
      image: 'https://i.ytimg.com/vi/fxZWY0ncJ6E/hq720.jpg',
      difficulty: 'Easy',
      time: '95',
      rating: 4.9,
      category: 'Dessert',
      cuisine: 'Italian'
    },
    {
      id: 15,
      videoId:"uxMw3XeudRA",
      title: 'Torta della nonna',
      description: "A classic Italian grandmother's cake.",
      image: 'https://i.ytimg.com/vi/uxMw3XeudRA/hq720.jpg',
      difficulty: 'Medium',
      time: '100',
      rating: 4.8,
      category: 'Dessert',
      cuisine: 'Italian'
    },
    {
      id: 16,
      videoId:"GSxWfKv2vl8",
      title: 'Pizza Napoletana',
      description: 'The authentic Neapolitan pizza.',
      image: 'https://i.ytimg.com/vi/GSxWfKv2vl8/hq720.jpg',
      difficulty: 'Hard',
      time: '65',
      rating: 4.9,
      category: 'Pastry',
      cuisine: 'Italian'
    },
    {
      id: 17,
      videoId:"mNQFYBWXEdA",
      title: 'Côte de Boeuf à la Plancha',
      description: 'A French-style grilled rib of beef.',
      image: 'https://i.ytimg.com/vi/mNQFYBWXEdA/hq720.jpg',
      difficulty: 'Medium',
      time: '30',
      rating: 4.8,
      category: 'Dinner',
      cuisine: 'French'
    },
    {
      id: 18,
      videoId:"AQWpKbjsl40",
      title: 'Poulet au Curry accompagné de son Riz',
      description: 'A French-style chicken curry with rice.',
      image: 'https://i.ytimg.com/vi/AQWpKbjsl40/hq720.jpg',
      difficulty: 'Medium',
      time: '50',
      rating: 4.7,
      category: 'Dinner',
      cuisine: 'French'
    },
    {
      id: 19,
      videoId:"NScrUuXYByI",
      title: 'Magret de Canard',
      description: 'A classic French duck breast dish.',
      image: 'https://i.ytimg.com/vi/NScrUuXYByI/hq720.jpg',
      difficulty: 'Medium',
      time: '40',
      rating: 4.9,
      category: 'Dinner',
      cuisine: 'French'
    },
    {
      id: 20,
      videoId:"6vABAWL-2Fo",
      title: 'Profiteroles',
      description: 'French choux pastry balls with a sweet filling.',
      image: 'https://i.ytimg.com/vi/6vABAWL-2Fo/hq720.jpg',
      difficulty: 'Medium',
      time: '60',
      rating: 4.8,
      category: 'Dessert',
      cuisine: 'French'
    },
    {
      id: 21,
      videoId:"sEtosp-_z1I",
      title: 'Crème Brûlée',
      description: 'A classic French dessert with a caramelized top.',
      image: 'https://i.ytimg.com/vi/sEtosp-_z1I/hq720.jpg',
      difficulty: 'Medium',
      time: '70',
      rating: 4.9,
      category: 'Dessert',
      cuisine: 'French'
    },
    {
      id: 22,
      videoId:"HX74mQSP6Bw",
      title: 'Soup de Pâtes',
      description: 'A simple French pasta soup.',
      image: 'https://i.ytimg.com/vi/HX74mQSP6Bw/hq720.jpg',
      difficulty: 'Easy',
      time: '25',
      rating: 4.6,
      category: 'Soup',
      cuisine: 'French'
    }
  ];

const cuisines = ['Turkish', 'American', 'Italian', 'French'];

const Recipes: React.FC = () => {
  const { t } = useTranslation();
  const [filteredRecipes, setFilteredRecipes] = useState<Recipe[]>(recipes);
  const [selectedCuisine, setSelectedCuisine] = useState<string>('Italian');

  useEffect(() => {
    const browserLang = navigator.language.split('-')[0];
    let defaultCuisine = 'Italian';
    if (browserLang === 'tr') {
      defaultCuisine = 'Turkish';
    } else if (browserLang === 'it') {
      defaultCuisine = 'Italian';
    } else if (browserLang === 'fr') {
      defaultCuisine = 'French';
    } else if (browserLang === 'en') {
      defaultCuisine = 'American';
    }
    setSelectedCuisine(defaultCuisine);
  }, []);

  useEffect(() => {
    if (selectedCuisine === 'All') {
      setFilteredRecipes(recipes);
    } else {
      const filtered = recipes.filter(recipe => recipe.cuisine === selectedCuisine);
      setFilteredRecipes(filtered);
    }
  }, [selectedCuisine]);

  return (
    <section id="recipes" className="recipes">
      <div className="container">
        <div className="recipes-header">
          <h2 className="section-title">{t('recipes.title')}</h2>
          <p className="section-subtitle">
            {t('recipes.subtitle')}
          </p>
        </div>

        <div className="filter-buttons">
          {cuisines.map(cuisine => (
            <button
              key={cuisine}
              className={`filter-btn ${selectedCuisine === cuisine ? 'active' : ''}`}
              onClick={() => setSelectedCuisine(cuisine)}
            >
              {t(`recipes.cuisines.${cuisine.toLowerCase()}`)}
            </button>
          ))}
        </div>

        <div className="recipes-grid">
          {filteredRecipes.map((recipe) => (
            <div key={recipe.id} className="recipe-card">
              <div className="recipe-image-wrapper">
                <img src={recipe.image} alt={recipe.title} className="recipe-image" />
                <div className="recipe-category-badge">{t(`recipes.categories.${recipe.category.toLowerCase()}`)}</div>
                <div className="recipe-rating-badge">
                  <span className="rating-star">⭐</span>
                  <span>{recipe.rating}</span>
                </div>
              </div>

              <div className="recipe-content">
                <h3 className="recipe-title">{recipe.title}</h3>
                <p className="recipe-description">{recipe.description}</p>

                <div className="recipe-meta">
                  <div className="meta-item">
                    <span className="meta-icon">⏱️</span>
                    <span className="meta-text">{recipe.time} {t('recipes.time_unit')}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-icon">📊</span>
                    <span className="meta-text">{t(`recipes.difficulties.${recipe.difficulty.toLowerCase()}`)}</span>
                  </div>
                </div>

                <Link to={`/recipe/${recipe.videoId}`} className="recipe-btn">
                  {t('recipes.viewRecipe')}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recipes;
